import moment from 'moment';
import { t } from '../i18n';

// Key suffixes under shared.training_session.
const SHORT_DESCRIPTORS = ['speedy', 'quick', 'brief', 'hasty'];
const LONG_DESCRIPTORS = ['lengthy', 'comprehensive', 'extensive', 'in_depth'];

const label = (key) => t(`shared.training_session.${key}`);

export function trainingSessionName(trainingSession) {
  if (trainingSession.live) {
    return label('live');
  }

  const descriptors = [
    getTimeOfDayDescriptor(trainingSession),
    getLengthDescriptor(trainingSession),
    getActivityDescriptor(trainingSession),
  ].filter(Boolean).join(' ');

  return t('shared.training_session.name', { descriptors });
}

function getTimeOfDayDescriptor(trainingSession) {
  const start = moment(trainingSession.created_at);
  const middleSessionTime = moment(start).add(moment(trainingSession.ended_at).diff(start) / 2);

  const momentTime = moment(middleSessionTime);
  const hour = momentTime.hours();
  const minutes = momentTime.minutes();

  if (hour >= 4 && hour < 7) {
    return label('early_morning');
  } if ((hour >= 7 && hour < 9) || (hour == 9 && minutes < 30)) {
    return label('morning');
  } if ((hour === 9 && minutes >= 30) || hour == 10 || (hour == 11 && minutes < 30)) {
    return label('late_morning');
  } if ((hour === 11 && minutes >= 30) || (hour >= 12 && hour < 14)) {
    return label('afternoon');
  } if ((hour >= 14 && hour < 16) || (hour == 16 && minutes < 30)) {
    return label('late_afternoon');
  } if ((hour == 16 && minutes >= 30) || (hour > 16 && hour < 18)) {
    return label('early_evening');
  } if (hour >= 18 && hour < 20) {
    return label('evening');
  } if (hour >= 20 && hour < 22) {
    return label('late_evening');
  } if (hour >= 22) {
    return label('nighttime');
  }
  return label('late_night');
}

function getLengthDescriptor(trainingSession) {
  const start = moment(trainingSession.created_at);
  const end = moment(trainingSession.ended_at);
  const sessionUuid = trainingSession.uuid;

  const lengthMinutes = end.diff(start, 'minutes');

  if (lengthMinutes <= 5) {
    const index = sessionUuid.charCodeAt(0) % SHORT_DESCRIPTORS.length;
    return label(SHORT_DESCRIPTORS[index]);
  } if (lengthMinutes >= 25) {
    const index = sessionUuid.charCodeAt(0) % LONG_DESCRIPTORS.length;
    return label(LONG_DESCRIPTORS[index]);
  }
  return '';
}

function getActivityDescriptor(trainingSession) {
  // TODO: get type of activity without n+1 from the back-end.
  // Goal: have "mixed", "coach-based", "routine-based", etc.
  return label('activity_training');
}
